var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "標準代碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "codeId"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入標準代碼" },
                            model: {
                              value: _vm.model.codeId,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "codeId", $$v)
                              },
                              expression: "model.codeId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "標準代碼名稱",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "codeDesc"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入標準代碼名稱" },
                            model: {
                              value: _vm.model.codeDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "codeDesc", $$v)
                              },
                              expression: "model.codeDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "父代碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "codeGroup"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入父代碼" },
                            model: {
                              value: _vm.model.codeGroup,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "codeGroup", $$v)
                              },
                              expression: "model.codeGroup"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "標準代碼類型",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "codeType"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入標準代碼類型" },
                            model: {
                              value: _vm.model.codeType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "codeType", $$v)
                              },
                              expression: "model.codeType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "描述",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "description"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入描述" },
                            model: {
                              value: _vm.model.description,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "description", $$v)
                              },
                              expression: "model.description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "是否有效",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "codeStatus"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入是否有效" },
                            model: {
                              value: _vm.model.codeStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "codeStatus", $$v)
                              },
                              expression: "model.codeStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "排序",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "orderNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入排序" },
                            model: {
                              value: _vm.model.orderNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "orderNo", $$v)
                              },
                              expression: "model.orderNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "更新時間",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "updateDate"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入更新時間" },
                            model: {
                              value: _vm.model.updateDate,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "updateDate", $$v)
                              },
                              expression: "model.updateDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "备注",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入备注" },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }